import React from "react";
import PropTypes from "prop-types";
import { primary, sealBlue } from "@govlaunch/palette";
import translatePropsIntoFontSize from "../measure/translatePropsIntoFontSize";

/**
 * @param  {Boolean} isOpen
 * @return {?Object}
 */
function applyOpenStyles({ isOpen }) {
  if (isOpen) {
    return {
      color: primary,
    };
  }

  return null;
}

export default function Placeholder({ children, ...props }) {
  return (
    <span
      css={{
        ...translatePropsIntoFontSize(props),
        textAlign: "left",
        lineHeight: "100%",
        overflow: "hidden",
        color: sealBlue,
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        display: "block",
        ...applyOpenStyles(props),
      }}
    >
      {children}
    </span>
  );
}

Placeholder.propTypes = {
  children: PropTypes.any.isRequired,
};
